import PropTypes from 'prop-types';
import React from 'react';
import ArticleLink from './ArticleLink';

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-param-reassign */

const SidebarItem = ({
  article,
  title,
  currentDepth,
  maxDepth,
  handleOnClick,
  category,
  children,
  expanded,
  isActiveUrl,
  hidden
}) => {
  let childBreadcrumbs;

  if (children && currentDepth < maxDepth) {
    const newDepth = currentDepth + 1;
    const items = children.filter(c => !c.hidden).map(child => (
      <SidebarItem
        {...child}
        article={child}
        key={child.url}
        currentDepth={newDepth}
        maxDepth={maxDepth}
        handleOnClick={handleOnClick}
      />
    ));
    childBreadcrumbs = <ul className={`sidebar-item-list sidebar-item-list-depth${newDepth} ${isActiveUrl ? 'is-current' : ''}`}>{items}</ul>;
  }

  if (hidden) return null;

  if (category) {
    return <li className="sidebar-category">{title}</li>;
  }

  return (
    <li
      className={`sidebar-item sidebar-item-depth${currentDepth} ${expanded && `expanded-${expanded}`} ${isActiveUrl ? 'is-current' : ''} `}
      onClick={handleOnClick}
    >
      <ArticleLink article={article}>
        {title}
      </ArticleLink>
      {childBreadcrumbs}
    </li>
  );
};

SidebarItem.propTypes = {
  article: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  currentDepth: PropTypes.number,
  maxDepth: PropTypes.number,
  isActiveUrl: PropTypes.bool,
  hidden: PropTypes.bool,
  category: PropTypes.string,
  children: PropTypes.array,
  expanded: PropTypes.string
};

export default SidebarItem;
